let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j9OUx")).then(() => parcelRequire('jSsWA'));